import axios from 'axios';

export const getFeatureCompatibility = async ({ sharedResourceId, includeTopLevel = true }, path) => {
    const { data } = await axios.get(`${path}/api/v2/sharedResources/${sharedResourceId}/editionFeatures?includeTopLevel=${includeTopLevel}`);

    return data;
};

export const getFeatureCompatibilityFromLink = async ({ linkId, includeTopLevel = true }, path) => {
    const { data } = await axios.get(`${path}/api/v2/links/${linkId}/editionFeatures?includeTopLevel=${includeTopLevel}`);

    return data;
};
